export default {
    abs: "абс.",
    activate: "Активировать",
    add_category: "Добавить категорию",
    add_kit: "Добавить комплект",
    additional_materials: "Дополнительные материалы",
    archive: "Архив",
    are_you_sure_you_want_to_delete_category: "Вы уверены, что хотите удалить категорию?",
    are_you_sure_you_want_to_delete_service: "Вы уверены, что хотите удалить услугу?",
    assistant_reward: "Вознаграждение ассистента",
    average_price: "Средняя цена",
    categories: "Категории",
    category: "Категория",
    change_category: "Изменить категорию",
    change_pricelist: "Изменить прайс",
    classificator_code: "Код по классификатору",
    classificator_title: "Название по классификатору",
    complex_service: "Комплексная услуга",
    complex_services: "Комплексные услуги",
    curator_reward: "Вознаграждение куратора",
    current_value: "Текущая стоимость",
    deactivate: "Деактивировать",
    decrease_price: "Уменьшить цену",
    discounted_price: "Цена со скидкой",
    do_not_accrue_bonus: "Не начислять бонус",
    doctor_reward: "Вознаграждение доктора",
    fill_from_previous_visits: "Заполнить из предыдущих визитов",
    fixed_materials_expense_sum: "Фиксированная сумма расхода на материалы",
    import_standard_services: "Импорт стандартных услуг",
    increase_price: "Увеличить цену",
    individual_bonus: "Индивидуальный бонус пациенту (%)",
    make_separate: "Сделать отдельным",
    manager: "Администратор",
    manager_reward: "Вознаграждение администратора",
    mkb_10_diagnosis: "Диагноз по МКБ 10",
    money_lost_on_discount: "Потеря денег на скидках",
    move_to_group: "Переместить в группу",
    ndfl_code: "Код НДФЛ",
    not_selected: "Не указан",
    packages_cost: "Себестоимость комплектов",
    personal_percent_for_assistant: "Персональный процент для ассистента",
    personal_percent_for_curator: "Персональный процент для куратора",
    personal_percent_for_doctor: "Персональный процент для доктора",
    personal_percent_for_manager: "Персональный процент для администратора",
    personal_percent_for_technic: "Персональный процент для техника",
    price_can_be_changed: "Цена может меняться в карточке лечения",
    price_from: "Цена от",
    pricelist_price: "Цена по прайсу",
    pricelist_short: "Прайс",
    reset_selection: "Сбросить выборку",
    send_to_archive: "Отправить в архив",
    Service: "Услуга",
    service_category: "Категория",
    service_code: "Код услуги",
    services_not_selected: "Услуги не выбраны",
    technic: "Техник",
    technic_reward: "Вознаграждение техника",
    teeth_not_selected: "Зубы не выбраны",
    use_visit_anamnez: "Использовать анамнез визита",
    visit_status: "Статус визита"
}
